<template>
    <div></div>
</template>

<script>
export default {
    name: "Auth",
    components: {},
    data() {
        return {}
    },
    mounted() {
        this.$API.commonConfig().then(res => {
            let app_id = res.data.app_id
            let redirect_uri = window.location.protocol + '//' + window.location.host
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + app_id + '&redirect_uri=' + redirect_uri + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
        });

    }
}
</script>

